export default "__VITE_ASSET__IW7CLxW$__"